import Vue from "vue";
import VueRouter from "vue-router";
import Signin from "@/components/SignIn";
import firebase from "firebase";

Vue.use(VueRouter);

const routes = [
  {
    path: "*",
    redirect: "/"
  },

  {
    path: "/",
    name: "home",
    component: () => import("../views/About.vue"),
    meta: { requiresAuth: true }
  },

  {
    path: "/signin",
    name: "Signin",
    component: Signin
  },

  {
    path: "/redirect_top",
    name: "redirect_system",
    component: () => import("../views/RedirectSystem/RedirectSys.vue"),
    meta: { requiresAuth: true }
  },

  {
    path: "/redirect_help",
    name: "redirect_help",
    component: () => import("../views/RedirectSystem/Help.vue"),
    meta: { requiresAuth: true }
  },

  {
    path: "/popular_article",
    name: "popular_article",
    component: () => import("../views/PopularArticle/Main.vue"),
    meta: { requiresAuth: true }
  },

  {
    path: "/engineer",
    name: "engineer",
    component: () => import("../views/Engineer/Main.vue"),
    meta: { requiresAuth: true }
  },

  {
    path: "/about",
    name: "about",
    component: () => import("../views/About.vue"),
    meta: { requiresAuth: true }
  },

  // {
  //   path: "/discord",
  //   name: "discord",
  //   component: () => import("../views/DiscordPost.vue"),
  //   meta: { requiresAuth: true }
  // },

  // {
  //   path: "/discord_post",
  //   name: "discord_post",
  //   component: () => import("../views/DiscordPost.vue"),
  //   meta: { requiresAuth: true }
  // },

  {
    path: "/discord_post",
    name: "discordPost",
    component: () => import("../views/Discord/List.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/discord_post/:id",
    name: "discordPostDetail",
    component: () => import("../views/Discord/Detail.vue"),
    meta: { requiresAuth: true }
  },



  {
    path: "/review",
    name: "review",
    component: () => import("../views/Review.vue"),
    meta: { requiresAuth: true }
  },

  {
    path: "/deck_manager",
    name: "deck_manager",
    component: () => import("../views/DeckManager.vue"),
    meta: { requiresAuth: true }
  },

  {
    path: "/top_banner",
    name: "top_banner",
    component: () => import("../views/TopBanner.vue"),
    meta: { requiresAuth: true }
  },

  {
    path: "/ads",
    name: "ads",
    component: () => import("../views/Ads/Main.vue"),
    meta: { requiresAuth: true }
  },

  {
    path: "/recommendAppli",
    name: "recommend_appli",
    component: () => import("../views/RecommendAppli/RecommendAppli.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/recommendAppli/sort",
    name: "recommend_appli_sort",
    component: () => import("../views/RecommendAppli/Sort.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/recommendAppli/all",
    name: "recommend_appli_allt",
    component: () => import("../views/RecommendAppli/All.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/recommendAppli/genre",
    name: "recommend_appli_genre",
    component: () => import("../views/RecommendAppli/Genre.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/recommendAppli/tag",
    name: "recommend_appli_tag",
    component: () => import("../views/RecommendAppli/Tag.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/recommendAppli/pr",
    name: "recommend_appli_pr",
    component: () => import("../views/RecommendAppli/PR.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/friend_bbs",
    name: "friend_bbs",
    component: () => import("../views/FriendBBS.vue"),
    meta: { requiresAuth: true }
  },

  {
    path: "/appli_db",
    name: "appli_db",
    component: () => import("../views/AppliManage/Main.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/appli_db/:id",
    name: "appliDetails",
    component: () => import("../views/AppliManage/AppliDetail.vue"),
    meta: { requiresAuth: true }
  },

  {
    path: "/linkcode/",
    name: "LinkCode",
    component: () => import("../views/Ads/LinkCode.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/inste_checker/",
    name: "insteChecker",
    component: () => import("../views/Ads/InsteChecker.vue"),
    meta: { requiresAuth: true }
  },

  {
    path: "/game_category/",
    name: "gameCategory",
    component: () => import("../views/GameCategory.vue"),
    meta: { requiresAuth: true }
  },

  {
    path: "/map_generate/",
    name: "mapGenerate",
    component: () => import("../views/MapGenerate/Main.vue"),
    meta: { requiresAuth: true }
  },

  {
    path: "/map_generate/:id",
    name: "mapDetail",
    component: () => import("../views/MapGenerate/mapGenerate.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/map_sub_generate/:parent_id/:id",
    name: "mapSubDetail",
    component: () => import("../views/MapGenerate/mapGenerate_sub.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/map_position/:parent_id",
    name: "mapPositionDetail",
    component: () => import("../views/MapGenerate/mapPosition.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/map_position/:parent_id/:id",
    name: "mapSubPositionDetail",
    component: () => import("../views/MapGenerate/mapPosition.vue"),
    meta: { requiresAuth: true }
  },


  {
    path: "/map_group/:slug",
    name: "mapGroupDetail",
    component: () => import("../views/MapGenerate/mapGroupSetting.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/map_group/:parent_id/:id",
    name: "mapSubGroupDetail",
    component: () => import("../views/MapGenerate/mapGroupSetting.vue"),
    meta: { requiresAuth: true }
  },



  {
    path: "/app_calendar/",
    name: "appCalendar",
    component: () => import("../views/AppCalendar.vue"),
    meta: { requiresAuth: true }
  },

  {
    path: "/master_duel_card/",
    name: "master_duel_card",
    component: () => import("../views/MasterDuelTool/CardList.vue"),
    meta: { requiresAuth: true }
  },

  {
    path: "/master_duel_deck/",
    name: "master_duel_deck",
    component: () => import("../views/MasterDuelTool/DeckList.vue"),
    meta: { requiresAuth: true }
  },

  {
    path: "/master_duel_limit/",
    name: "master_duel_limit",
    component: () => import("../views/MasterDuelTool/EventLimitList.vue"),
    meta: { requiresAuth: true }
  },

  {
    path: "/rush_duel_card/",
    name: "rush_duel_card",
    component: () => import("../views/RushDuel/CardList.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/rush_duel_getmaster/",
    name: "rush_duel_getmaster",
    component: () => import("../views/RushDuel/GetMethodList.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/rush_duel_deck/",
    name: "rush_duel_deck",
    component: () => import("../views/RushDuel/DeckRecipe.vue"),
    meta: { requiresAuth: true }
  },

  // {
  //   path: "/cross_duel_skill/",
  //   name: "cross_duel_skill",
  //   component: () => import("../views/CrossDuel/SkillList.vue"),
  //   meta: { requiresAuth: true }
  // },

  // {
  //   path: "/cross_duel_deck_recipe/",
  //   name: "cross_duel_deck_recipe",
  //   component: () => import("../views/CrossDuel/DeckRecipe.vue"),
  //   meta: { requiresAuth: true }
  // },

  // {
  //   path: "/cross_duel_get_method/",
  //   name: "cross_duel_get_method",
  //   component: () => import("../views/CrossDuel/GetMethodList.vue"),
  //   meta: { requiresAuth: true }
  // },

  //画像掲示板にアップロードされている画像一覧
  {
    path: "/image_bbs/",
    name: "image_bbs",
    component: () => import("../views/ImageBBS.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/form_list/",
    name: "form_list",
    component: () => import("../views/FormList.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/anaytics/",
    name: "anaytics",
    component: () => import("../views/Anaytics.vue"),
    meta: { requiresAuth: true }
  }
  // {
  //   path: "/master_duel/",
  //   name: "master_duel_deck",
  //   component: () => import("../views/MasterDuel/DeckList.vue"),
  //   meta: { requiresAuth: true }
  // },
  // {
  //   path: "/master_duel/:id",
  //   name: "master_duel_deck_detail",
  //   component: () => import("../views/MasterDuel/DeckDetail.vue"),
  //   meta: { requiresAuth: true }
  // }
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);

  // ルート認証があるかチェック
  if (requiresAuth) {
    // ユーザログインのチェック
    firebase.auth().onAuthStateChanged(function(user) {
      if (user) {
        console.log("ログイン中");
        //ログインしていてサインインのページに飛んだ時はHOMEにする
        if (to["name"] == "Signin") {
          next({
            path: "/",
            query: { redirect: to.fullPath }
          });
        } else {
          next();
        }
      } else {
        console.log("Not Login");
        next({
          name: "Signin"
        });
      }
    });
  } else {
    // ルートの認証を設定していない場合はこっ
    console.log("ログイン認証なし");
    next();
  }
});

export default router;
